import React, { Component } from "react";

import styles from "./styles.scss";

import CSSModules from "react-css-modules";
import { Button, CircularProgress } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Route, Switch } from "react-router";
import * as router from "react-router-redux";
import masterImportService from "../../services/masterImport";
import masterRuleService from "../../services/masterRule";
import GeneratedChildRules from "../../components/GeneratedChildRules/GeneratedChildRules";


@CSSModules(styles, { allowMultiple: true })
class MasterRulesOverview extends Component {

  constructor(props) {

    super(props);
    this.state = {
      isBusy: true,
      masterRules: null
    };
  }

  componentDidMount() {
    this.getMasterRules();
  }

  async getMasterRules() {

    try {

      this.setState({ isBusy: true });

      let rules = await masterImportService.getAllMasterRules();

      if (rules == null || !rules.length)
        rules = null;

      console.log(rules);

      this.setState({ masterRules: rules, isBusy: false });

    } catch (e) {
      let rules = null;
      this.setState({ masterRules: rules, isBusy: false });
    }
  }

  async applyPendingUpdates(masterRule, index) {
    try {

      let newMasterRules = [];
      for(let ii = 0, ilen = this.state.masterRules.length; ii < ilen; ii++) {
        if(ii == index) {
          newMasterRules.push({...this.state.masterRules[ii], masterRuleStatus: null, hasAppliedChanges: true})
        } else {
          newMasterRules.push(this.state.masterRules[ii]);
        }
      }

      this.setState({ masterRules: newMasterRules });
      await masterImportService.applyChildRuleChangesForMasterRule(masterRule.masterRuleInstanceId);

      this.checkForChangedMasterRules([masterRule.masterRuleInstanceId], 0, index);
    } catch(e) {

      console.error("Exception encountered while trying to apply child rule changes.");
      console.error(e);

    } finally {
      //masterRule.applyingChanges = true;
      this.setState({ masterRules: this.state.masterRules });
    }
  }

  async checkForChangedMasterRules(appliedMasterRules, count, index) {
    if(count >= 120) {
      console.error("The master rules did not finish within 10 minutes and will no longer continue to be polled by the page.");
      return;
    }
    let masterRuleStatus = [];
    
    for(let ii = 0, ilen = appliedMasterRules.length; ii < ilen; ii++) {
      let masterRule = await masterRuleService.getMasterRule(appliedMasterRules[ii]);
      masterRuleStatus.push({masterRuleInstanceId: masterRule.masterRuleInstanceId, updateStatusCode: masterRule.updateStatusCode});
    }

    let numberOfApplyingMasterRules = masterRuleStatus.filter(x => x.updateStatusCode != '');
    if(numberOfApplyingMasterRules.length > 0) {
      let newMasterRules = [];
      for(let ii = 0, ilen = this.state.masterRules.length; ii < ilen; ii++) {
        if(ii == index) {
          newMasterRules.push({...this.state.masterRules[ii], masterRuleStatus, hasAppliedChanges: true})
        } else {
          newMasterRules.push(this.state.masterRules[ii]);
        }
      }
      this.setState({ masterRules: newMasterRules });
      setTimeout(() => {
        this.checkForChangedMasterRules(appliedMasterRules, count++, index);
      }, 5000);
    } else {
      let newMasterRules = [];
      for(let ii = 0, ilen = this.state.masterRules.length; ii < ilen; ii++) {
        if(ii == index) {
          newMasterRules.push({...this.state.masterRules[ii], masterRuleStatus: null})
        } else {
          newMasterRules.push(this.state.masterRules[ii]);
        }
      }
      this.setState({ masterRules: newMasterRules });
    }
  }


  render() {

    if (this.state.isBusy === true)
      return <div className={"center-children full-height"}><CircularProgress /></div>;

    if (this.state.masterRules == null || this.state.masterRules.length === 0)
      return (
        <div className={"center-children margin-v-0"}>
          <span>There are currently no master rules registered with the system.</span>
        </div>
      );

    return (

      <div style={{padding: "1rem"}}>

        <div style={{ marginLeft: "0.5rem" }}>
          <h2>Master Rules</h2>
          <span>The following master rules exist in the system.</span>
        </div>

        {/* List of Master Rules down the Left */}
        <div className="key-config-split-container"
             style={{ marginTop: "2rem", border: "1px solid lightgrey" }}>

          <div className="key-column">

            <table className="lightweight-table">
              <thead>
              <tr>
                <th>Master Rule</th>
                <th>Child Rules</th>
                <th>Last Updated</th>
                <th>New</th>
                <th>Modified</th>
                <th>{/* This is the 'Apply' column */}</th>
              </tr>
              </thead>
              <tbody>
              {this.state.masterRules.map((x, i) => {
                return (
                  <tr key={i} className="key-entry">

                    <td>
                      <Link to={`/MasterRules/All/${x.masterRuleInstanceId}`}>
                        {x.textId}
                      </Link>
                    </td>
                    <td>{x.activeRules}</td>
                    <td>{x.modifiedOnUtc.toLocaleDateString('en-GB', {day: '2-digit', month: '2-digit', year: 'numeric'})}</td>
                    <td>{x.pendingNew}</td>
                    <td>{x.pendingModified}</td>
                    <td>
                      {(x.pendingNew > 0 || x.pendingModified > 0)
                        ? x.applyingChanges == null || x.applyingChanges == false || x.updateStatusCode == 'Waiting' || x.updateStatusCode == ''
                          ? <Button variant="raised"
                                    onClick={() => this.applyPendingUpdates(x, i)} disabled={x.hasAppliedChanges}>
                              Apply
                            </Button>
                          : <Button disabled><CircularProgress style={{height: "22px", width: "22px"}} /></Button>
                        : ""}
                      {
                        x.masterRuleStatus != null && x.masterRuleStatus.length > 0 &&
                        <div className={"indefinite-load"}>
                          <span></span>
                          <div>{x.masterRuleStatus.length} rule{x.masterRuleStatus.length>1?'s are ':' is '}currently applying.</div>
                        </div>
                      }
                    </td>
                  </tr>

                );
              })}
              </tbody>
            </table>


          </div>

          {/* Configuration data for selected tag label */}
          <div className="config-column">

            <Switch>
              <Route path={`/MasterRules/All/:ruleId`} component={GeneratedChildRules}
                     key={"import-status-rules" + this.state.ruleId}></Route>
              <Route path={`/MasterRules/All`}>
                <div className={"center-children full-height"}>
                  <span>Select a master rule on the left to see child rules.</span>
                </div>
              </Route>
            </Switch>

          </div>

        </div>

      </div>
    );

  }

}

export default MasterRulesOverview;



// WEBPACK FOOTER //
// ./src/ui/MasterRulesOverview/MasterRulesOverview.js